import {Component, OnInit} from '@angular/core';
import {UserService} from "./shared/user.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'axing-angular';
  loaded = false;

  constructor(
    private uService: UserService
  ) {
    this.uService.getUser().subscribe(resp => {
      if (resp && resp.username) {
        this.loaded = true;
      } else {
        this.uService.notiService.open("Error: Something went wrong");
      }
    })
  }

  ngOnInit(): void {

  }
}
